import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiHomeDataBlock = class PiHomeDataBlock extends Vue {
    constructor() {
        super(...arguments);
        this.type = 1;
        this.echartType = 1;
    }
    typeClick(type) {
        this.type = type;
        this.$emit("on-type-change", type);
    }
    echartTypeClick() {
        this.echartType = this.echartType == 1 ? 2 : 1;
        this.$emit("on-echart-change", this.echartType);
    }
    refreshClick() {
        this.$emit("on-refresh-change");
    }
    moutend() {
        this.typeClick(1);
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeDataBlock.prototype, "titleTextBg", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeDataBlock.prototype, "dateType", void 0);
__decorate([
    Prop({ default: false })
], PiHomeDataBlock.prototype, "refresh", void 0);
PiHomeDataBlock = __decorate([
    Component
], PiHomeDataBlock);
export default PiHomeDataBlock;
